let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5A56H"), load("9tgTm"), load("aptN5"), load("u2Avf"), load("cG8Sb")]).then(() => parcelRequire('3h4RJ'));